





















































































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import ContentImage from './SourceContentInfoContentImage.vue'

import Env from '@/env'

import Vote from './SourceContentInfoVote.vue'
import Chip from './SourceContentInfoChip.vue'
import FormComment from '@/components/FormComment.vue'
import { commentFields } from '@/GraphQL/fragments'

@Component({
  components: { ContentImage, Chip, Vote, FormComment },
})
export default class SourceContentInfo extends Vue {
  @Prop() url!: string
  @Prop({ default: false, required: false, type: Boolean }) noReply!: boolean

  get decodedUrl(): string {
    return decodeURIComponent(this.url)
  }

  source: any = null

  loadingWebpageData: boolean = true
  webpageData: any = {
    title: '',
    img: '',
  }

  @Watch('loadingWebpageData')
  onLoadingWebpageDataChanged(val) {
    if (!val) {
      if (this.webpageData.title) {
        document.title = this.webpageData.title + ' - ' + this.$appName
      } else {
        document.title = this.decodedUrl + ' - ' + this.$appName
      }
    }
  }

  comment: string = '' // a reply
  replying: boolean = false
  postingComment: boolean = false

  addToBookmarks() {
    const query = `
      mutation ADD_TO_BOOKMARKS($uid: String!, $title: String, $thumbnail: String) {
        addToBookmarks(uid: $uid, title: $title, thumbnail: $thumbnail) {
          uid
        }
      }`
    const variables = {
      uid: this.source.uid,
      title: this.webpageData.title,
      thumbnail: this.webpageData.img,
    }
    this.$http.get('graphql', { params: { query, variables } })
      .then(r => {
        if (r.data.errors) return
        this.source.isBookmarked = true
        this.$eventBus.$emit('snackbar', {
          text: `Post saved successfully`, action: {
            text: 'Undo',
            callback: () => this.removeFromBookmarks(),
          },
        })
      })
  }

  removeFromBookmarks() {
    const query = `
      mutation REMOVE_FROM_BOOKMARKS($uid: String!) {
        removeFromBookmarks(sourceUid: $uid) {
          uid
        }
      }`
    const variables = {
      uid: this.source.uid,
    }
    this.$http.get('graphql', { params: { query, variables } })
      .then(r => {
        if (r.data.errors) return
        this.source.isBookmarked = false
        this.$eventBus.$emit('snackbar', { text: `Post unsaved successfully` })
      })
  }

  postComment() {
    this.postingComment = true
    const query = `
      mutation CREATE_COMMENT($sourceURL: String, $body: String!) {
        createComment(sourceURL: $sourceURL, body: $body) {
          ${commentFields}
        }
      }`
    const variables = {
      sourceURL: this.decodedUrl,
      body: this.comment,
    }

    this.$http.get('graphql', { params: { query, variables } })
      .then(r => {
        if (r.data.errors) return
        this.comment = ''
        this.replying = false
        this.$emit('reply', { comment: r.data.data.createComment })
        // this.comments.unshift(r.data.data.createComment)
        this.$nextTick(() => {
          this.$vuetify.goTo(`#comment-${r.data.data.createComment.uid}`)
        })
      })
      .finally(() => {
        this.postingComment = false
      })

  }

  // getWebpageData() {
  //   let getWebpageDataApiUrl = Env.getWebpageDataApiUrl
  //   this.loadingWebpageData = true
  //   this.$http.get(getWebpageDataApiUrl, { params: { url: this.decodedUrl } })
  //     .then(response => {
  //       this.webpageData.title = response.data.title
  //       this.webpageData.img = response.data.img
  //     })
  //     .catch(err => console.error(err))
  //     .finally(() => {
  //       this.loadingWebpageData = false
  //     })
  // }

  getSource() {
    let query = `
      query GET_SOURCE($url: String!) {
        source(url: $url) {
          uid
          title
          ogImage
          votesUpCount
          votesDownCount
          myVote
          meritsCount
          demeritsCount
          isBookmarked
        }
      }`
    let variables = {
      url: this.decodedUrl,
    }
    this.$http.get('graphql', { params: { query, variables } })
      .then(r => {
        this.source = r.data.data.source
      })
      .catch(err => console.error(err))
  }

  created() {
    // this.getWebpageData()
    this.getSource()
  }

}

